<a class="pointer" appBackButton> < Volver</a>
<div class="jumbotron animated fadeIn fast">
  <h2 class="title">¿Qué solicitud necesitas?</h2>
  <form [formGroup]="form" class="row">
    <div class="col-sm-12 col-md-12 col-lg-9">
      <div class="row">
        <div class="col-md-3">
          <div class="form-group">
            <label class="label-form" for="">Número de Solicitud</label>
            <input
              class="form-control"
              formControlName="number"
              mask="00000000000"
              [validation]="true"
            />
          </div>
        </div>
        <div class="col-md-3">
          <div class="form-group has-feedback">
            <label class="label-form" for="">Tipo de Solicitud</label>
            <select class="form-control" formControlName="type">
              <option value="" disabled selected>Seleccione</option>
              <option
                *ngFor="let type of requestTypes"
                value="{{ type.value }}"
              >
                {{ type.name }}
              </option>
            </select>
            <i
              class="glyphicon glyphicon-menu-down form-control-feedback custom-select-arrow"
            ></i>
          </div>
        </div>
        <div class="col-md-3">
          <div class="form-group has-feedback">
            <label class="label-form" for="">Fecha de carga Solicitud</label>
            <app-datepicker
              [control]="form.get('date')"
              [controlName]="'date'"
              [formRef]="form"
            ></app-datepicker>
          </div>
        </div>
        <div class="col-sm-3 col-md-3 col-lg-3">
          <div class="form-group has-feedback">
            <label class="label-form" for="">Estado</label>
            <select class="form-control" formControlName="state">
              <option value="" disabled selected>Seleccione</option>
              <option *ngFor="let state of states" value="{{ state.value }}">
                {{ state.name | titlecase }}
              </option>
            </select>
            <i
              class="glyphicon glyphicon-menu-down form-control-feedback custom-select-arrow"
            ></i>
          </div>
        </div>
      </div>
    </div>
    <div class="col-sm-12 col-md-12 col-lg-3 text-center">
      <div class="row">
        <div class="col col-md-6 form-group">
          <button
            [disabled]="disabled"
            (click)="search()"
            class="form-control button"
          >
            Buscar
          </button>
        </div>
        <div class="col col-md-6 form-group">
          <button
            [disabled]="disabled"
            class="form-control button-clear"
            (click)="reset()"
          >
            Limpiar filtro
          </button>
        </div>
      </div>
    </div>
  </form>
</div>
<h2 class="title">
  Resultados búsqueda de solicitud ({{ _request.requestSearch.length }})
</h2>
<app-loading *ngIf="loading"></app-loading>
<app-search-result
  *ngIf="!loading && !error && _request.requestSearch.length > 0"
  [requests]="_request.requestSearch"
></app-search-result>
<app-no-results
  *ngIf="!loading && sent && error"
  [data]="error"
></app-no-results>
